type MarketFunctionSupport = {
  [marketNameEnglish: string]: {
    marketname: string;
    marketIconUrl: string;
    [functionName: string]: string;
  };
};

export const NEED_INVITE_MANNAGER = '매니저 초대가 필요합니다. 편집 > 가이드보기';

export const MARKET_FUNCTION_SUPPORT: MarketFunctionSupport = {
  smartstore: {
    marketname: '스마트스토어',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSmartstore.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'O',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
    changePassword: 'X',
    disconnectAvailable: 'O',
    changeAlias: 'X',
  },
  coupang: {
    marketname: '쿠팡',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketCoupang.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  '11st': {
    marketname: '11번가',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarket11st.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  'gmarket-new': {
    marketname: 'G마켓',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketGmarket.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  'auction-new': {
    marketname: '옥션',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketAuction.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  lotteon: {
    marketname: '롯데온',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketLotteon.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  interpark: {
    marketname: '인터파크',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketInterpark.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'O',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  ably: {
    marketname: '에이블리',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketAbly.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  cafe24: {
    marketname: '카페24',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketCafe24.png',
    주문수집: 'O',
    '정산금 수집': 'X',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  zigzag: {
    marketname: '지그재그',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketZigzag.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  melchi: {
    marketname: '멸치쇼핑',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSmelchi.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  idus: {
    marketname: '아이디어스',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketIdus.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  talkstore: {
    marketname: '카카오톡 스토어',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketTalkstore.png',
    주문수집: 'O',
    '정산금 수집': 'X',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'X',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  imweb: {
    marketname: '아임웹',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketImweb.png',
    주문수집: 'O',
    '정산금 수집': 'X',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'O',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  sixshop: {
    marketname: '식스샵',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSixshop.png',
    주문수집: 'O',
    '정산금 수집': 'X',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'O',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  'sixshop-pro': {
    marketname: '식스샵 프로',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSixshopPro.png',
    주문수집: 'O',
    '정산금 수집': 'X',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'O',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  shopby: {
    marketname: '샵바이',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketShopby.png',
    주문수집: 'O',
    '정산금 수집': 'X',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  alwayz: {
    marketname: '올웨이즈',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketAlwayz.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'X',
    '문의 답변 작성': 'X',
  },
  toss: {
    marketname: '토스',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketToss.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'X',
    '발송처리 및 송장입력': 'X',
    '상품 취소 처리': 'X',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'X',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
  pallang: {
    marketname: '팔랑',
    marketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketPallang.png',
    주문수집: 'O',
    '정산금 수집': 'O',
    주문확인처리: 'O',
    '발송처리 및 송장입력': 'O',
    '상품 취소 처리': 'O',
    '클레임 접수': 'O',
    '리뷰 수집': 'O',
    '리뷰 답변 작성': 'O',
    '문의 수집': 'O',
    '문의 답변 작성': 'O',
  },
};

export const MARKET_TEXTBOX_OPTIONAL_LIST: {
  [key: string]: { title: string };
} = {
  VendorId: { title: '업체코드' },
  AccessKey: { title: 'AccessKey' },
  SecretKey: { title: 'SecretKey' },
  MarketId: { title: 'ID' },
  MarketPassword: { title: '비밀번호' },
  marketName: { title: '마켓명' },
  marketId: { title: '아이디' },
  marketPassword: { title: '비밀번호' },
};

export const HIDDEN_MARKET_ENG = ['wemakeprice', 'tmon', 'esmplus', 'gmarket', 'auction'];
